var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.235352 17V0.648438H6.10889C8.21273 0.648438 9.8112 1.03402 10.9043 1.80518C12.0049 2.57633 12.5552 3.69564 12.5552 5.16309C12.5552 6.00911 12.3605 6.73161 11.9712 7.33057C11.5819 7.92952 11.0091 8.37126 10.2529 8.65576C11.1064 8.88037 11.7616 9.29964 12.2183 9.91357C12.675 10.5275 12.9033 11.2762 12.9033 12.1597C12.9033 13.7619 12.3942 14.9673 11.376 15.7759C10.3652 16.577 8.8641 16.985 6.87256 17H0.235352ZM4.17725 10.0483V13.9678H6.76025C7.47152 13.9678 8.01807 13.8068 8.3999 13.4849C8.78174 13.1554 8.97266 12.695 8.97266 12.1035C8.97266 10.7409 8.29508 10.0558 6.93994 10.0483H4.17725ZM4.17725 7.46533H6.23242C7.09342 7.45785 7.70736 7.30062 8.07422 6.99365C8.44108 6.68669 8.62451 6.23372 8.62451 5.63477C8.62451 4.94596 8.42611 4.45182 8.0293 4.15234C7.63249 3.84538 6.99235 3.69189 6.10889 3.69189H4.17725V7.46533Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.856ad98f.svg";
export { ForwardRef as ReactComponent };